import React, { PropsWithChildren } from 'react';
import c from 'classnames';

import './Table.styl';

interface Props<RecordType> {
  record: RecordType;
  onExpand: (record: RecordType, e: React.MouseEvent<HTMLElement>) => void;
  expanded: boolean;
}

function ExpandIcon<RecordType>({
  record,
  onExpand,
  expanded,
}: PropsWithChildren<Props<RecordType>>) {
  return (
    <div onClick={e => onExpand(record, e)}>
      <i
        className={c('iconfont icon-arrow_down', 'mio-table-next-expand-icon', {
          'mio-table-next-expand-icon-expanded': expanded,
        })}
      />
    </div>
  );
}

export default ExpandIcon;